export default __webpack_public_path__ + "static/media/urgentAction.04d7e392.svg";